/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import { customInstance } from "../../config/mutator";

export const getAdmin = () => {
  /**
 * Sends a test message via the Iterable email template sync service

Required authority: PERM_SUPER_ADMIN
 * @summary Trigger a test message
 */
  const triggerMessage = () => {
    return customInstance<string>({ url: `/api/admin/trigger-message`, method: "GET" });
  };
  /**
 * Asynchronously kicks off a sync of Iterable email template IDs

Required authority: PERM_SUPER_ADMIN
 * @summary Trigger Iterable template sync
 */
  const triggerIterableSync = () => {
    return customInstance<string>({ url: `/api/admin/trigger-iterable-sync`, method: "GET" });
  };
  /**
 * Sync email types synchronously

Required authority: PERM_SUPER_ADMIN
 */
  const triggerIterableEmailTypeSync = () => {
    return customInstance<string>({ url: `/api/admin/trigger-email-type-sync`, method: "GET" });
  };
  return { triggerMessage, triggerIterableSync, triggerIterableEmailTypeSync };
};
export type TriggerMessageResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAdmin>["triggerMessage"]>>
>;
export type TriggerIterableSyncResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAdmin>["triggerIterableSync"]>>
>;
export type TriggerIterableEmailTypeSyncResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAdmin>["triggerIterableEmailTypeSync"]>>
>;
